import { APIService } from '../../shared/services/APIService';

export class DiagramCommentService extends APIService {
  getAllComments() {
    return this.http.get('/diagramComments');
  }

  
}